// material-ui
import { useColorScheme } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

// project imports
import { ThemeMode } from 'config';

// assets
import { IconSun, IconMoon, IconDeviceDesktop } from '@tabler/icons-react';

// ==============================|| HEADER - THEME MODE TOGGLE ||============================== //

export default function ThemeModeSection() {
  const { mode, setMode } = useColorScheme();

  const handleToggle = () => {
    if (mode === ThemeMode.LIGHT) {
      setMode(ThemeMode.DARK);
    } else if (mode === ThemeMode.DARK) {
      setMode(ThemeMode.SYSTEM);
    } else {
      setMode(ThemeMode.LIGHT);
    }
  };

  const label =
    mode === ThemeMode.DARK ? 'Dark Mode' : mode === ThemeMode.LIGHT ? 'Light Mode' : 'System Mode';

  const icon =
    mode === ThemeMode.DARK ? (
      <IconMoon stroke={1.5} size="20px" style={{ transform: 'rotate(220deg)' }} />
    ) : mode === ThemeMode.LIGHT ? (
      <IconSun stroke={1.5} size="20px" />
    ) : (
      <IconDeviceDesktop stroke={1.5} size="20px" />
    );

  return (
    <Tooltip title={label}>
      <IconButton color="secondary" onClick={handleToggle} aria-label="toggle theme mode">
        {icon}
      </IconButton>
    </Tooltip>
  );
}
